export interface RootState {
  authId: string;
  documentId: string;
  recipientId: string;
  userId: string;
  videoReminderId?: string;
  isPreview: boolean;
  previewExpired: boolean;
  pusherConnected: boolean;
}

export enum RootMutation {
  SetIds = 'setIds',
  SetPreviewMode = 'setPreviewMode',
  SetPreviewExpired = 'setPreviewExpired',
  SetPusherConnected = 'setPusherConnected',
}

export enum RootAction {
  SetIds = 'setIds',
  SetPreviewMode = 'setPreviewMode',
  SetPreviewExpired = 'setPreviewExpired',
  SetPusherConnected = 'setPusherConnected',
}
